import React from "react";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import { ConventionLogoSquare } from "../../events/ConventionLogo";
import { formatConventionDateNoSubmission, formatLocation, formatSessionDate } from "@seabrookstudios/pitch2table-core";
import Avatar from "@mui/material/Avatar";
import ListItemButton from "@mui/material/ListItemButton";
import { useNavigate } from "react-router-dom";
import { Path } from "../../Path";
import { useMyProfile } from "@seabrookstudios/pitch2table";
import AccessTime from "@mui/icons-material/AccessTime";

/**
 * Renders a session list entry.
 * @param {{ session: import("@seabrookstudios/pitch2table-core").Session }} props
 */
const SessionListEntry = ({ session }) => {
  const { data: profile } = useMyProfile();
  const navigate = useNavigate();

  const primary = session.type === "Pitching" ? "Pitching Session" : "Play Testing Session";
  const secondary = formatSessionDate(session.date, profile?.location?.timezone);

  const onClickHandler = () => {
    navigate(Path.session(session.id));
  };

  return (
    <ListItemButton alignItems="flex-start" selected={false} onClick={onClickHandler}>
      <ListItemAvatar>
        <Avatar>
          <AccessTime />
        </Avatar>
      </ListItemAvatar>
      <ListItemText primary={primary} secondary={secondary} />
    </ListItemButton>
  );
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").CalendarEvent} props.convention
 */
const ConventionListEntry = ({ convention }) => {
  const navigate = useNavigate();

  const onClickHandler = () => {
    navigate(Path.events().event(convention.id));
  };

  return (
    <ListItemButton onClick={onClickHandler}>
      <ListItemAvatar>
        <ConventionLogoSquare convention={convention} width={48} height={48} />
      </ListItemAvatar>
      <ListItemText
        primary={convention.name}
        secondary={`${formatConventionDateNoSubmission(convention)} • ${formatLocation(convention)}`}
      />
    </ListItemButton>
  );
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").ListItem} props.item
 */
export const ListEntry = ({ item }) => {
  if (item.type === "Session") {
    return <SessionListEntry session={item.data} />;
  }

  return <ConventionListEntry convention={item.data} />;
};
